import { render, staticRenderFns } from "./ProductServices.vue?vue&type=template&id=178750d1&scoped=true&"
import script from "./ProductServices.vue?vue&type=script&lang=js&"
export * from "./ProductServices.vue?vue&type=script&lang=js&"
import style0 from "./ProductServices.vue?vue&type=style&index=0&id=178750d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178750d1",
  null
  
)

export default component.exports